import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTwitch = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="m5.313 1-.25.656-3 8L2 9.812V43h11v6h7.406l.313-.281L26.437 43h8.97l.312-.281L48 30.437V1Zm1.375 2H46v26.594L34.594 41h-9l-6 6H15v-6H4V10.188ZM10 5v30h8v7.406l1.719-1.687L25.437 35h11.97l.312-.281 6-6 .281-.313V5Zm2 2h30v20.563L36.563 33h-11.97l-.312.281L20 37.563V33h-8Zm8 6v14h6V13Zm10 0v14h6V13Zm-8 2h2v10h-2Zm10 0h2v10h-2Z" />
    </svg>
);
export default SvgTwitch;
